import { ButtonTriggerEvent } from '../../../common/components';
import { HubPlace } from '../../../models/hub/hub.place';

export class EditPlaceCategoryModalActions {
    confirm: (event: ButtonTriggerEvent, category: {
        category: string,
        categoryList: string[],
        categoryText: string
    }) => void;
    cancel?: () => void;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.place.category.modal/edit.place.category.modal.provider.ts